/* eslint-disable no-unused-vars */

import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useState, useEffect, useCallback } from 'react';
import ModalDetail from './components/ModalDetail';
import SearchGroup from './components/search_group/SearchGroup';
import { message, Form } from 'antd';
import webStorage from '@/utils/storageManager';

const MemberManagement = (props) => {
  const [selectIdBoolean, setSelectIdBoolean] = useState(false);
  const [selectItem, setSelectItem] = useState({});
  // const [copyId, setCopyId] = useState('');
  const [addOptions, setAddOptions] = useState([]);
  const [editableGetFecth, setEditableGetFecth] = useState(true);

  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['md/getModalList'];
  const datas = useSelector((state) => state.md.getModalList);
  const addTable = useSelector((state) => state.md.getQueryField);

  // 获取会员列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'md/getModalList',
      payload: {
        values: { modelId: props.location.query.modelID },
      },
      callback: (res) => {
        if (res && res.length > 0) {
          setEditableGetFecth(res[0].editable);
        }
      },
    });
  }, [dispatch]);

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        res &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  value: item2.id,
                  label: item2.fieldName,
                });
              });
            if (item.fields.length === 0) {
              child.push({
                value: null,
                label: '无',
              });
            }
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setAddOptions(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  const handleSearch = (e) => {
    if (e.id) {
      datas.forEach((item) => {
        if (item.id === e.id) {
          setSelectItem(item);
          setSelectIdBoolean(true);
        }
      });
    } else {
      setSelectIdBoolean(false);
    }
  };

  const deleteModalField = (e) => {
    dispatch({
      type: 'md/deleteModalField',
      payload: {
        modelId: e.id,
        values: { operator: '' },
      },
      callback: () => {
        message.success('删除成功');
        fetchData();
      },
    });
  };

  const onAdd = (e) => {
    if (e.fieldIds.length > 0) {
      dispatch({
        type: 'md/addModelField',
        payload: {
          values: {
            fieldIds: e.fieldIds.slice(1),
            modelId: props.location.query.modelID,
          },
        },
        callback: (res) => {
          if (res && res.ids) {
            message.success('新增成功');
            fetchData();
          } else if (res) {
            message.error(res.message);
          }
        },
      });
    }
  };

  const menuClick = (a, b) => {
    if (a === '1') {
      // setCopyId(b.id);
      webStorage.set('COPYID', b.id);
      message.success('复制成功');
    } else if (a === '2') {
      dispatch({
        type: 'md/pasteRule',
        payload: {
          values: {
            fromModelField: webStorage.get('COPYID'),
            toModel: props.location.query.modelID,
            // toModel: b.id,
          },
        },
        callback: (res) => {
          console.log(res);
          if (res.code) {
            message.error(res.message);
          } else {
            message.success('粘贴成功');
          }
        },
      });
    }
  };

  let tableData = selectIdBoolean ? [selectItem] : datas || [];
  let options = [];
  let addSelectOptions = [];
  if (datas && datas.length > 0) {
    datas.forEach((item) => {
      options.push({ value: item.id, name: item.fieldName });
    });
  }
  if (addTable) {
    addTable &&
      addTable.forEach((item) => {
        addSelectOptions.push({ name: item.fieldName, value: item.id });
      });
  }
  return (
    <div className={styles.mm_content}>
      <div
        className={classnames(styles.search_group, styles.single_component1)}
      >
        <SearchGroup
          {...props}
          options={options}
          addOptions={addOptions}
          handleSearch={handleSearch}
          onAdd={onAdd}
          editableGetFecth={editableGetFecth}
        />
      </div>
      <div className={classnames(styles.table_page, styles.single_component)}>
        <ModalDetail
          {...props}
          loading={loading}
          tableData={tableData}
          menuClick={menuClick}
          deleteModalField={deleteModalField}
          editableGetFecth={editableGetFecth}
        />
      </div>
    </div>
  );
};

export default MemberManagement;
